import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

interface UiState {
  notificationDropdownOpen: boolean;
  accountMenuOpen: boolean;
}

const initialState: UiState = {
  notificationDropdownOpen: false,
  accountMenuOpen: false,
};

const uiSlice = createSlice({
  name: "ui",
  initialState,
  reducers: {
    setNotificationDropdownOpen: (state, action: PayloadAction<boolean>) => {
      state.notificationDropdownOpen = action.payload;
    },
    setAccountMenuOpen: (state, action: PayloadAction<boolean>) => {
      state.accountMenuOpen = action.payload;
    },
  },
});

export const {
  setNotificationDropdownOpen,
  setAccountMenuOpen,
} = uiSlice.actions;
export default uiSlice.reducer;
